import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46fa8896")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["__modalsContainer", { '__show': _ctx.items.length > 0 }]
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
      return (_openBlock(), _createBlock("div", {
        class: "__modalBg",
        key: i,
        ref: '__modalBg' + i,
        onMousedown: ($event: any) => (_ctx.onDownBg($event, i)),
        onMouseup: ($event: any) => (_ctx.onUpBg($event, i)),
        onTouchstart: ($event: any) => (_ctx.onDownBg($event, i)),
        onTouchend: ($event: any) => (_ctx.onUpBg($event, i)),
        style: 'z-index: ' + (1 + i)
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(item.modalComponent), _mergeProps(item.props, {
          onClose: ($event: any) => (_ctx.closeModal(i))
        }), null, 16, ["onClose"]))
      ], 44, ["onMousedown", "onMouseup", "onTouchstart", "onTouchend"]))
    }), 128))
  ], 2))
})